import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-consultas-ejecutar',
  templateUrl: './consultas-ejecutar.component.html',
  styleUrls: ['./consultas-ejecutar.component.scss']
})
export class ConsultasEjecutarComponent implements OnInit {

  cargandoListaConsultas: boolean = true;
  registrosLista: any = [];
  consultas: any[] = [];

  constructor(public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService) { }

  ngOnInit(): void {
    this.getListado();
  }

  /**
 * Listados
 */
  getListado() {
    this.cargandoListaConsultas = true;
    this.coreService.get('/cabecera-consulta-activa').subscribe(
      (res: any[]) => {
        this.registrosLista = res;

        this.registrosLista.forEach(element => {
          this.consultas.push({ label: element.titulo + ' (' + element.programa + ')', value: element.id });
        });

        this.cargandoListaConsultas = false;

      },
      (err: any) => {
        this.cargandoListaConsultas = false;
        console.log(err);
      }
    )
  }

}
